import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { Box, Grid, LinearProgress } from '@mui/material';

import { LayoutDashboard } from '../../../shared/layouts';
import { GenericService } from '../../../shared/services';
import { CompanyFilterDTO, UserDTO, WorkItemDTO, WorkItemFilterDTO, ValueListDTO, AccessRoleDTO, AccessRoleFilterDTO, PeopleDTO } from '../../../shared/interfaces';
import { ISnackbarAlert, SnackbarAlert, CardList, ToolBar, IDialogActions, ICardActions, ICardColumns, IChipFilter, SelectField, TextFieldInput, KanbanList, ISwitchInputProps } from '../../../shared/components';
import { Delete } from '../../../shared/components/confirm-delete/ConfirmDelete';
import { ListId, LocalStorange } from '../../../shared/environment';
import { CompanyDTO } from '../../../shared/interfaces/corpSphere/CompanyDTO';
import { WorkItemMaintenance } from './WorkItemMaintenance';

export interface IWorkItemProps {
    data: any;
}

export const WorkItem: React.FC<IWorkItemProps> = ({data}) => {

    const [typeList, setTypeList] = useState<ValueListDTO[]>([]);
    const [categoryList, setCategoryList] = useState<ValueListDTO[]>([]);
    const [statusList, setStatusList] = useState<ValueListDTO[]>([]);
    const [responsibleList, setResposibleList] = useState<PeopleDTO[]>([]);
    const [assigninList, setAssigninList] = useState<PeopleDTO[]>([]);
    const [companyList, setCompanyList] = useState<CompanyDTO[]>([]);
    
    const [workItemList, setWorkItemList] = useState<WorkItemDTO[]>([]);
    const [workItemFilterDTO, setWorkItemFilterDTO] = useState<WorkItemFilterDTO>();

    const [cardMoved, setCardMoved] = useState<any>();
    const [checkedKanban, setCheckedKanban] = useState(true);

    const [actionExecuted, setActionExecuted] = useState(false);

    const [newRecord, setNewRecord] = useState('');
    const [editRecord, setEditRecord] = useState('');
    const [deleteRecord, setDeleteRecord] = useState('');
    const [expadedData, setExpandedData] = useState('');
    const [isOpenMaintenance, setIsOpenMaintenance] = useState(false);
    const [proposal, setProposal] = useState('');

    const [loading, setLoading] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState<ISnackbarAlert>();
    const [isOpenSnackBar, setIsOpenSnackBar] = useState(false);

    const [accessRolePermissionDTO, setAccessRolePermissionDTO] = useState<AccessRoleDTO>();
    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');

    useEffect(() => {
        setWorkItemFilterDTO({
            ...workItemFilterDTO,
            name: '',
            code: '',
            tag: '',
            typeId: '',
            statusId: '',
            targetDate: undefined,
            startDateTime: undefined,
            endDateTime: undefined,
            assigninId: '',
            ownerId: ''
        } as WorkItemFilterDTO);
    }, []);


    useEffect(() => {
        handleListGetAll(ListId.worksphere.workItem.typeId, setTypeList);
        handleListGetAll(ListId.worksphere.workItem.statusId, setStatusList);

        handleCompanyGetAll();
        handleWorkItemGetAllViewAsync();

        handleGetPermission(ListId.worksphere.workItemId, setAccessRolePermissionDTO);
    }, [workItemFilterDTO]);

    useEffect(() => {
        if (actionExecuted)
            handleWorkItemGetAllViewAsync();
    }, [actionExecuted]);

    useEffect(() => {
        handleMoveTaskKanbanAsync();
    }, [cardMoved]);

   
    const handleGetPermission = useCallback(async (featureId: string, setList: any) => {
        const accessRoleFilterDTO: AccessRoleFilterDTO = {
            featureId: featureId,
            userId: userInfo.user.id,
        };
        GenericService.PostGenericAsync1('authsphere.AccessRole', 'GetPermissionAsync', accessRoleFilterDTO, setActionExecuted, setLoading, undefined, setList);
    }, []);

    const handleMoveTaskKanbanAsync = useCallback(async () => {
        if (cardMoved === undefined || cardMoved.id === undefined || cardMoved.statusId === undefined) {
            return;
        }
        const workItemId = cardMoved.id;
        const statusId = cardMoved.statusId;
        const index = cardMoved.index;

        const workItemDTO = {
            id: workItemId,
            statusId: statusId,
            kanbanIndex: index,
            updatedById: userInfo.user.Id
        };
        GenericService.PostGenericAsync1('worksphere.workItem', 'MoveTaskKanbanAsync', workItemDTO, setActionExecuted, setLoading, showMessage);
    }, [cardMoved]);

    const handleCompanyGetAll = useCallback(async () => {
        const companyFIlterDTO: CompanyFilterDTO = {
            name: '',
            businessRelationshipTypeId: '',
            statusId: '',
            orderBy: 'name ASC'
        };
        GenericService.GetAllAsync1('corpsphere.company', companyFIlterDTO, setLoading, setCompanyList, showMessage);
    }, []);

    const handleListGetAll = useCallback(async (listId: string, setList: any) => {
        const valueListFilterDTO = {
            value: '',
            listId: listId,
            orderBy: 'valueindex, value ASC'
        };
        GenericService.GetAllAsync1(
            'parmsphere.valueList',
            valueListFilterDTO,
            setLoading,
            setList,
            showMessage
        );
    }, []);

    const handlePeopleGetAllAsync = useCallback(async (setList: any) => {
        const userFilterDTO = {
            // companyId: workItemFilterDTO?.companyId,
        };
        GenericService.GetAllAsync1('corpsphere.people', userFilterDTO, setLoading, setList, showMessage);
    }, [workItemFilterDTO]);

    const handleWorkItemGetAllViewAsync = useCallback(async () => {
        if (workItemFilterDTO === undefined)
            return;
        if (accessRolePermissionDTO?.allowGetAllView == undefined)
            return;
        if (!accessRolePermissionDTO?.allowGetAllView) {
            showMessage('There is no permission for get all view.', 'info');
            return;
        } 
        GenericService.GetAllViewAsync1('worksphere.workItem', workItemFilterDTO, setActionExecuted, setLoading, setWorkItemList, showMessage, true);
    }, [workItemFilterDTO, accessRolePermissionDTO]);

    const handleClearFilterClick = () => {
        setWorkItemFilterDTO({
            ...workItemFilterDTO,
            name: '',
            code: '',
            externalCode: '',
            statusId: '',
            responsibleId: '',
            requesterId: '',
            typeId: '',
            companyId: userInfo.user.companyId
        } as WorkItemFilterDTO);
    };

    function handleSearchClick() {
        handleWorkItemGetAllViewAsync();
    }

    const handleNew = () => {
        if (!accessRolePermissionDTO?.allowAdd) {
            showMessage('There is no permission for new record.', 'info');
            return;
        }
        setNewRecord('data');
        setEditRecord('');
        setDeleteRecord('');
        setIsOpenMaintenance(true);
        setProposal('');
    };

    const handleViewDetatils = (data: string) => {
        if (!accessRolePermissionDTO?.allowGetById) {
            showMessage('There is no permission for view details.', 'info');
            return;
        }
        setNewRecord('');
        setEditRecord(data);
        setDeleteRecord('');
        setIsOpenMaintenance(true);
        setProposal('');
    };

    const handleDelete = (data: string) => {
        if (!accessRolePermissionDTO?.allowDelete) {
            showMessage('There is no permission for delete record.', 'info');
            return;
        }
        setNewRecord('');
        setEditRecord('');
        setDeleteRecord(data);
        setIsOpenMaintenance(true);
        setProposal('');
    };

    const handleProposal = (data: string) => {
        setNewRecord('');
        setEditRecord('');
        setDeleteRecord('');
        setIsOpenMaintenance(true);
        setProposal(data);
    };

    const toolBarActions: IDialogActions[] = [
        { id: 'new', text: 'New WorkItem', icon: 'add_circle_outlined', iconColor: 'primary', setAction: handleNew },
    ];

    const cardActions: ICardActions[] = [
        { id: 'viewDetails', toolTip: 'View Details', icon: 'preview_outlined', iconColor: 'primary', setAction: handleViewDetatils },
        { id: 'delete', toolTip: 'Delete', icon: 'delete_outlined', iconColor: 'error', setAction: handleDelete },
    ];

    const chipFilters: IChipFilter[] = [
        { label: 'Total Records', value: workItemList.length },
        { label: 'Name', value: workItemFilterDTO?.name },
        { label: 'Code', value: workItemFilterDTO?.code },
        { label: 'Tag', value: workItemFilterDTO?.tag },
        { label: 'Type', value: typeList.find(x => x.id === workItemFilterDTO?.typeId)?.value },
        { label: 'Status', value: statusList.find(x => x.id === workItemFilterDTO?.statusId)?.value },
        { label: 'Assignin', value: responsibleList.find(x => x.id === workItemFilterDTO?.assigninId)?.fullName },
        { label: 'Owner', value: companyList.find(x => x.id === workItemFilterDTO?.ownerId)?.id },
    ];

    const columns: ICardColumns[] = [
        { field: 'code', label: 'code', size: 2, type: 'text', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        { field: 'name', label: 'Name', size: 4, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'startDateTime', label: 'Start Date', size: 2, type: 'date', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'endDateTime', label: 'End Date', size: 2, type: 'date', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'targetDateTime', label: 'Target Date', size: 1, type: 'date', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'type', label: 'Type', size: 2, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: false },
        { field: 'assignin', label: 'Assignin', size: 2, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: false },
        { field: 'status', label: 'Status', size: 2, type: 'text', visible: true, isChip: true, hasFieldLine: false, hasToolTip: false },
        { field: 'owner', label: 'Owner', size: 2, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },

    ];

    const kanbanColumns: ICardColumns[] = [
        { field: 'name', label: 'Name', size: 12, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'code', label: 'code', size: 12, type: 'text', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        { field: 'targetDateTime', label: 'Expected Closing', size: 12, type: 'date', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'assignin', label: 'Assignin', size: 12, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'owner', label: 'Owner', size: 12, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },

    ];

    const kanbanSwitch: ISwitchInputProps = {
        id: 'workItem.switch', label: 'View Kanban|View List', checked: checkedKanban, setChecked: setCheckedKanban, disabled: false, autoFocus: false, color: 'info', size: 'small', labelPlacement: 'end'
    };

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarMessage(msg);
        setIsOpenSnackBar(true);
    }

    return (
        <React.Fragment>
            {isOpenSnackBar && (
                <SnackbarAlert
                    snackBarAlert={snackBarMessage}
                    setIsOpen={setIsOpenSnackBar}
                    isOpen={isOpenSnackBar}
                />
            )}
            <LayoutDashboard title='OPORTUNITY'>
                <ToolBar
                    clickSearch={handleSearchClick}
                    clickClearFilter={handleClearFilterClick}
                    chipFilters={chipFilters}
                    actions={toolBarActions}
                    kanbanSwitch={kanbanSwitch}
                >
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={3}>
                            <TextFieldInput
                                id='name'
                                label='Name'
                                placeholder={'Name'}
                                setValue={setWorkItemFilterDTO}
                                value={workItemFilterDTO?.name}
                                obj={workItemFilterDTO}
                                maxLength={200}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextFieldInput
                                id='code'
                                label='Code'
                                placeholder={'Code'}
                                setValue={setWorkItemFilterDTO}
                                value={workItemFilterDTO?.code}
                                obj={workItemFilterDTO}
                                maxLength={200}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextFieldInput
                                id='tag'
                                label='Tag'
                                placeholder={'Tag'}
                                setValue={setWorkItemFilterDTO}
                                value={workItemFilterDTO?.tag}
                                obj={workItemFilterDTO}
                                maxLength={200}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='statusId'
                                label='Status'
                                setValue={setWorkItemFilterDTO}
                                value={workItemFilterDTO?.statusId}
                                obj={workItemFilterDTO}
                                valueList={statusList}
                                hasNoneSelect={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='typeId'
                                label='Company'
                                setValue={setWorkItemFilterDTO}
                                value={workItemFilterDTO?.typeId}
                                obj={workItemFilterDTO}
                                valueList={typeList}
                                hasNoneSelect={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <SelectField
                                id='assigninId'
                                label='Assignin'
                                setValue={setWorkItemFilterDTO}
                                value={workItemFilterDTO?.assigninId}
                                obj={workItemFilterDTO}
                                valueList={assigninList}
                                hasNoneSelect={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextFieldInput
                                id='ownerId'
                                label='Owner'
                                placeholder={'Owner'}
                                setValue={setWorkItemFilterDTO}
                                value={workItemFilterDTO?.ownerId}
                                obj={workItemFilterDTO}
                                maxLength={200}
                            />
                        </Grid>
                    </Grid>
                </ToolBar>
                {loading && (
                    <LinearProgress sx={{ borderRadius: 3, mt: - 0.7, mb: 0.2 }} />
                )}
                {checkedKanban ? (
                    <Box sx={{ display: 'flex', height: 'calc(100vh - 280px)', minHeight: 520, width: '100%', overflow: 'hidden' }}>
                        <KanbanList
                            identifierField='statusId'
                            cards={workItemList}
                            attributes={kanbanColumns}
                            statusList={statusList}
                            setRowExpanded={setExpandedData}
                            setCardMoved={setCardMoved}
                            actions={cardActions}
                            cardSize={2}
                        />
                    </Box>
                ) : (
                    <Box sx={{ display: 'flex', maxHeight: '80vh', width: '100%', overflow: 'hidden', overflowY: 'auto' }}>
                        <CardList
                            columns={columns}
                            rows={workItemList}
                            actions={cardActions}
                            cardSize={12}
                            hasChildren={false}
                            setRowExpanded={() => void undefined}
                        />
                    </Box>
                )}
                {newRecord && (
                    <WorkItemMaintenance
                        data={''}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                    />
                )}
                {editRecord && (
                    <WorkItemMaintenance
                        data={editRecord}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                    />
                )}
                {deleteRecord && (<Delete
                    entity={'worksphere.workItem'}
                    data={deleteRecord}
                    setIsOpenDiaglog={setIsOpenMaintenance}
                    isOpenDialog={isOpenMaintenance}
                    setActionExecuted={setActionExecuted}
                />)}
            </LayoutDashboard>
        </React.Fragment >
    );
};
